var map = {
	"./screen1.png": 352,
	"./screen10.png": 353,
	"./screen2.png": 354,
	"./screen3.png": 355,
	"./screen4.png": 356,
	"./screen5.png": 357,
	"./screen6.png": 358,
	"./screen7.png": 359,
	"./screen8.png": 360,
	"./screen9.png": 361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 351;